(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-table-module"] = factory();
	else
		root["vue-table-module"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 